export default function menuToggle() {
  const menuTrigger = document.querySelectorAll('#menu-trigger')
  const menuItems = document.querySelectorAll('#menu-content a')
  const header = document.querySelector('header')

  const menu = document.querySelector('#menu-content')

  console.log(menuTrigger, menuItems)

  menuItems.forEach(item => {
    item.addEventListener('click', () => {
      menu.classList.remove('active')
    })
  })

  menuTrigger.forEach(mT => {
    mT.addEventListener('click', () => {
      console.log('CLICK')
      menu.classList.toggle('active')
      header.classList.toggle('active')
    })
  })

}
